import AsyncStorage from '@react-native-async-storage/async-storage';
import { Image } from 'expo-image';
import * as Updates from 'expo-updates';
import { useEffect } from 'react';
import { Platform } from 'react-native';
import { cacheDirectory, deleteAsync } from 'expo-file-system/legacy';

const STORAGE_KEY = 'last_known_update_id';

/** Αυτόματος καθαρισμός cache μόλις εντοπιστεί νέο EAS update. Σιωπηλός, χωρίς UI. */
export function useAutoClearCacheOnUpdate() {
  useEffect(() => {
    if (Platform.OS === 'web') return;

    const currentId = Updates.updateId ?? null;
    if (!currentId) return;

    void AsyncStorage.getItem(STORAGE_KEY).then(async (stored) => {
      if (stored === currentId) return;
      try {
        await Promise.all([
          Image.clearDiskCache(),
          Image.clearMemoryCache(),
          cacheDirectory ? deleteAsync(cacheDirectory, { idempotent: true }) : Promise.resolve(),
        ]);
      } catch { /* αγνόησε */ }
      await AsyncStorage.setItem(STORAGE_KEY, currentId);
    });
  }, []);
}
